import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import ReactSelect from 'react-select';
import usePotionSelectProps from './use-potion-select-props';
const Select = forwardRef((props, ref) => {
    const potionSelectProps = usePotionSelectProps(props);
    return _jsx(ReactSelect, Object.assign({ ref: ref }, potionSelectProps), void 0);
});
export default Select;
